export default {
  product: {
    wishlist: {
      added: 'Produto adicionado aos favoritos',
      removed: 'Produto removido dos favoritos',
      addAriaLabel: 'Adicionar aos favoritos',
      removeAriaLabel: 'Remover dos favoritos',
    },
    addToFolder: 'Adicionar à pasta',
    actions: {
      addToCart: 'Adicionar ao carrinho',
      addingToCart: 'A adicionar...',
    },
    viewDescription: 'Ver descrição',
    quantity: 'Quantidade',
    decreaseQuantity: 'Diminuir quantidade',
    increaseQuantity: 'Aumentar quantidade',
    value: 'Valor',
    priceOnRequestTooltip: 'Preço sob consulta. Não é possível adicionar ao carrinho.',
    card: {
      from: 'Desde',
      inStock: 'Em Stock',
      outOfStock: 'Sem stock',
    },
    gallery: {
      mainImageAlt: '{{productName}}',
      thumbnailAlt: '{{productName}} — imagem {{index}} de {{total}}',
      openAlt: 'Ampliar imagem de {{productName}}',
    },
    groupedInfo: {
      includedProducts: 'Produtos incluídos',
      total: 'Total',
      timesQuantitySets: '× {{quantity}} conjuntos',
      perSet: '/ conjunto',
    },
    priceTiers: {
      title: 'Tabela de Preços',
      pricePerUnitHeader: 'Preço / Un. (Com IVA)',
      pricePerUnitExVatHeader: 'Preço / Un. (Sem IVA)',
      disclaimer:
        '* Os preços apresentados são meramente indicativos e podem variar consoante a personalização e stock disponível.',
      close: 'Fechar',
      viewTable: 'Tabela de preços',
      perUnit: '/ unidade',
    },
    tabs: {
      description: 'Descrição',
      technicalInfo: 'Informações técnicas',
      fileSpecifications: 'Ficha técnica',
      stock: 'Stock',
      noDescription: 'Sem descrição disponível para este produto.',
      noSpecifications: 'Sem informações técnicas disponíveis para este produto.',
      noDocuments: 'Sem documentos disponíveis para este produto.',
      noStockInfo: 'Sem informação de stock disponível para este produto.',
      upcomingRestock: 'Próximas reposições',
      restockEntry: '{{quantity}} unidades a partir de {{date}}',
      packaging: 'Embalagem',
      sectionAriaLabel: 'Detalhes do produto',
      tabsAriaLabel: 'Secções do produto',
    },
    info: {
      vatIncluded: 'IVA incluído',
      exVat: 'Sem IVA:',
      inclVat: 'Com IVA:',
      startCustomization: 'Iniciar personalização',
      atAGlance: {
        material: 'Material',
        dimensions: 'Medidas',
      },
      outOfStockTooltip: 'Produto sem stock disponível',
      outOfStockLabel: 'Sem estoque',
      availableFrom: 'Disponível a partir de: {{date}}',
      inStock: 'Em stock',
      lowStock: 'Stock limitado',
      deliveryEstimate: 'Prazo Mínimo: {{days}} dias úteis',
    },
    page: {
      loading: 'Loading product...',
      error: 'Error loading product',
      addToCartSuccess: 'Produto adicionado ao carrinho',
      addToCartError: 'Erro ao adicionar produto ao carrinho',
      bundleAddedToCart: 'Conjunto adicionado ao carrinho',
      bundleAddToCartError: 'Erro ao adicionar conjunto ao carrinho',
      moreProductsIn: 'Mais produtos em {{section}}',
    },
    relatedCarousel: {
      scrollLeft: 'Scroll left',
      scrollRight: 'Scroll right',
    },
  },
  catalog: {
    breadcrumbs: {
      ariaLabel: 'Breadcrumb',
      home: 'Início',
      products: 'Produtos',
      search: 'Pesquisa',
      bestSellers: 'Best Sellers',
      featured: 'Destaques',
      promotions: 'Promoções',
      stockoff: 'Liquidação',
    },
    sort: {
      label: 'Ordenar por:',
      alphabetical: 'Alfabético',
      priceDesc: 'Maior Preço',
      priceAsc: 'Menor Preço',
      bestSellers: 'Mais Vendidos',
      newest: 'Mais Recentes',
    },
    filters: {
      title: 'Filtros',
      clearAll: 'Limpar tudo',
      price: 'Preço',
      priceMin: 'Mínimo',
      priceMax: 'Máximo',
      apply: 'Aplicar',
      typeTitle: 'Destaques',
      featured: 'Recomendados',
      isNew: 'Novidade',
      promotion: 'Promoção',
      bestSellers: 'Mais vendidos',
      mobileTitleProducts: 'Filtrar Produtos',
      mobileTitleResults: 'Filtrar Resultados',
      closeAriaLabel: 'Fechar',
      closeOverlayAriaLabel: 'Fechar filtros',
    },
    badges: {
      featured: 'Recomendado',
      bestSeller: 'Mais vendidos',
    },
    categoriesPage: {
      title: 'Categorias',
      subtitle: 'Explore as nossas categorias de produtos',
      loading: 'A carregar categorias...',
      error: 'Erro ao carregar categorias',
    },
    categoryPage: {
      loading: 'Loading category...',
      error: 'Error loading category',
      notFound: 'Categoria não encontrada.',
      resultCount: 'A mostrar {{count}} produtos',
      noProducts:
        'Não há produtos com estes filtros. Ajuste ou limpe os filtros para ver mais resultados.',
    },
    searchPage: {
      resultsTitle: 'Resultados da pesquisa para "{{query}}"',
      searching: 'A pesquisar...',
      resultsCount: 'Encontrámos {{count}} produtos',
      loading: 'A carregar...',
      error: 'Erro ao carregar resultados',
      noProductsFiltered:
        'Não foram encontrados produtos para a sua pesquisa. Ajuste ou limpe os filtros para ver mais resultados.',
      noProducts: 'Não foram encontrados produtos para a sua pesquisa.',
    },
    bestSellersPage: {
      subtitle: 'Os produtos mais vendidos e procurados pelos nossos clientes.',
      loading: 'A carregar best sellers...',
      error: 'Erro ao carregar best sellers',
      empty: 'Neste momento não existem produtos marcados como best sellers.',
      badge: 'Best Seller',
    },
    featuredPage: {
      subtitle: 'Descubra os nossos produtos em destaque.',
      loading: 'A carregar destaques...',
      error: 'Erro ao carregar destaques',
      empty: 'Neste momento não existem produtos em destaque.',
      badge: 'Destaque',
    },
    promotionsPage: {
      subtitle: 'Aproveite as nossas melhores ofertas e descontos.',
      loading: 'A carregar promoções...',
      error: 'Erro ao carregar promoções',
      empty: 'Neste momento não existem produtos em promoção.',
    },
    stockoffPage: {
      subtitle: 'Aproveite as últimas unidades! Produtos em fim de coleção com preços imperdíveis.',
      loading: 'A carregar produtos em liquidação...',
      error: 'Erro ao carregar produtos',
      empty: 'Neste momento não existem produtos em liquidação.',
    },
  },
}
